module.exports = __webpack_public_path__ + "img/congmobanfaqi.0aaf6bf2.png";